module.exports = __webpack_public_path__ + "static/media/(DH)_MG_4723_-_Pro-Natura_-_Moda_Feminina_-_Acessorios.af9d7d1d.jpg";